import { IUser } from '@interfaces/IUser';

export const usersGroups: { [key: string]: { name: string; color: string } } = {
  admins: {
    name: 'Админ',
    color: 'lightgreen',
  },
  students: {
    name: 'Студент',
    color: 'lightsalmon',
  },
  teachers: {
    name: 'Преподаватель',
    color: 'lightblue',
  },
  mentors: {
    name: 'Ментор',
    color: 'lightseagreen',
  },
  accountant: {
    name: 'Бухгалтер',
    color: 'thistle',
  },
  sales_admin: {
    name: 'Cейлз админ',
    color: 'plum',
  },
  sales_managers: {
    name: 'Cейлз менеджер',
    color: 'lightyellow',
  },
  companies: {
    name: 'Компании',
    color: 'lightpink',
  },
};

export interface IUserStateErrors {
  password?: string[];
  first_name?: string[];
  last_name?: string[];
  confirm_password?: string[];
  email?: string[];
  phone_number?: string[];
  telegram_number?: string[];
  detail?: string;
  how_did_you_know?: string[];
}

export interface IUserState {
  users: IUser[];
  count: number;
  unconfirmedCount: number;
  selectedUser: IUser | null;
  errors: IUserStateErrors;
  message: string;
  isValidToken: boolean;
  loading?: {
    [key: string]: boolean;
  };
  importErrors?: {
    file: string[];
    group: string[];
  } | null;
  importSkipped: {
    text: string;
    users: string[];
  } | null;
  groups: { id: number; name: string }[];
  error: { [key: string]: { [key: string]: string[] } };
  profileTabsLoading: boolean;
}

export const initialUserState: IUserState = {
  users: [],
  selectedUser: null,
  errors: {},
  message: '',
  isValidToken: false,
  importSkipped: null,
  importErrors: null,
  groups: [],
  count: 0,
  unconfirmedCount: 0,
  error: {},
  profileTabsLoading: false,
};
